import { isNativeApp } from "./platform";

export type DeepLinkHandler = (url: string) => void;

/**
 * Native only: route deep-link opens to `handler`. Fires for warm opens
 * (`appUrlOpen`) and once for the cold-start launch URL (not delivered via
 * `appUrlOpen`). Returns an async unsubscribe — `await` it and store the
 * result; do NOT hand it straight to a React effect cleanup, it is a Promise,
 * not a sync function. No-op on web.
 */
export async function onDeepLink(
  handler: DeepLinkHandler,
): Promise<() => void> {
  if (!isNativeApp()) return () => {};
  const { App } = await import("@capacitor/app");
  const handle = await App.addListener("appUrlOpen", (event) => {
    handler(event.url);
  });
  try {
    const launch = await App.getLaunchUrl();
    if (launch?.url) handler(launch.url);
  } catch {
    // No launch URL available.
  }
  return () => {
    void handle.remove();
  };
}
